import { StageGroup } from '@recruitee/stages-types';
import type { StageGroupValue } from '@recruitee/stages-types';

export const STAGE_GROUPS_IN_ORDER: StageGroup[] = [
  StageGroup.Applicants,
  StageGroup.Active,
  StageGroup.Hires,
  StageGroup.Other,
];

export const STAGES_I18N: Record<StageGroupValue, string> = {
  [StageGroup.Applicants]: 'app.stages.divider.applicants_stages',
  [StageGroup.Active]: 'app.stages.divider.active_process_stages',
  [StageGroup.Hires]: 'app.stages.divider.hires_stages',
  [StageGroup.Other]: 'app.stages.divider.other_stages',
};
